import config from 'config';
import request from 'helpers/superagent';

export default () => {
  return request.get("https://icanhazip.com/")
    .endAsync()
    .get('text')
};



/** WEBPACK FOOTER **
 ** ./src/app/helpers/fetchIpAsync.js
 **/